import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine, CartesianGrid } from "recharts";
import { ChartCard } from "./Card";
import { tokens } from "./styles";

// Your standardized scores over time (by attempt sequence) against the cohort
// average and the pass mark — your trajectory vs the cohort. Treated as a
// comparison card: shown only once there's a cohort average to plot against.
export function trendVisible(data) {
  return Boolean(data?.available && data.points?.length && data.cohort_avg != null);
}

export default function ScoreTrend({ data }) {
  if (!trendVisible(data)) return null;

  const { points, cohort_avg, pass_mark } = data;
  const bySeq = Object.fromEntries(points.map((p) => [p.seq, p]));

  return (
    <ChartCard title="Your score trend" hint="Mocks and the diagnostic, in order">
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={points} margin={{ top: 8, right: 12, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={tokens.ink200} vertical={false} />
          <XAxis dataKey="seq" tick={{ fontSize: 10, fill: tokens.ink400 }} allowDecimals={false} />
          <YAxis domain={[0, 100]} tick={{ fontSize: 10, fill: tokens.ink400 }} />
          <Tooltip
            formatter={(value) => [`${value}%`, "Score"]}
            labelFormatter={(seq) => {
              const p = bySeq[seq];
              return p ? `${p.exam_type} · ${p.date}` : `Attempt ${seq}`;
            }}
          />
          {pass_mark != null && (
            <ReferenceLine y={pass_mark} stroke={tokens.ink400} strokeDasharray="5 4"
              label={{ value: `Pass ${pass_mark}%`, position: "insideTopRight", fontSize: 10, fill: tokens.ink500 }} />
          )}
          {cohort_avg != null && (
            <ReferenceLine y={cohort_avg} stroke={tokens.ink500}
              label={{ value: `Cohort avg ${cohort_avg}%`, position: "insideBottomRight", fontSize: 10, fill: tokens.ink500 }} />
          )}
          <Line type="monotone" dataKey="score" stroke={tokens.accent} strokeWidth={2}
            dot={{ r: 4, fill: tokens.accent }} activeDot={{ r: 5 }} />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
